<div class="record-table card-x">
    <p-table [value]="tableData" [loading]="isTableLoading" dataKey="id" [paginator]="true" [rows]="10"
        [totalRecords]="totalRecords" (onPage)="onPage($event)" [rowsPerPageOptions]="[5, 10, 20]" [pageLinks]="4"
        [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} items"
        [expandedRowKeys]="expandedRows" (onRowExpand)="onRowExpand($event)" (onRowCollapse)="onRowCollapse($event)"
        styleClass="table-dark-header" 
        [sortField]="sortField"
        [sortMode]="'single'"
        [customSort]="true"
        [sortOrder]="sortOrder"
        (onSort)="onSort($event)">

        <ng-template pTemplate="header">
            <tr>
                <th [pSortableColumn]="'formattedId'">
                    Request Number
                    <p-sortIcon field="formattedId"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'recordSubject'">
                    Record Subject
                    <p-sortIcon field="recordSubject"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'providerName'">
                    Provider Name (Institution) / Doctor
                    <p-sortIcon field="providerName"></p-sortIcon>
                </th>
                <th style="max-width:25%" [pSortableColumn]="'address'">
                    Address / Phone Number
                    <p-sortIcon field="address"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'recordRequestType'">
                    Record Request Type
                    <p-sortIcon field="recordRequestType"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'dateOfServices'">
                    Date of Services
                    <p-sortIcon field="dateOfServices"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'status'">
                    Status
                    <p-sortIcon field="status"></p-sortIcon>
                </th>
                <th style="max-width:25%">
                    Status Message
                </th>
                <th alignFrozen="right" pFrozenColumn style="width: 5rem;" valign="top" aria-label="Action Column">
                    <span class="sr-only">Action Column</span>
                    <i id="need-help-icon"
                        tabIndex="0"
                        aria-label=""
                        class="pi pi-question-circle pointer"
                        (click)="op.toggle($event)">
                    </i>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" #body let-rowData let-expanded="expanded">
            <tr>
                <td data-label="Order Number" valign="top">{{ rowData.formattedId }}</td>
                <td data-label="Record Subject" valign="top" data-openreplay-obscured>{{ rowData.recordSubject }}</td>
                <td data-label="Provider Name (Institution) / Doctor" valign="top">
                    <div class="d-flex flex-column">
                        <label>{{ rowData.providerName }}</label>
                        <div>
                            <span class="sr-only"> Doctor name - </span>
                            <label  class="text-break">{{ rowData.doctor || '--'}}</label>
                        </div>
                    </div>
                </td>
                <td data-label="Address / Phone Number" valign="top">
                    <div class="d-flex flex-column">
                        <label data-openreplay-obscured>{{ rowData.address }}</label>
                        <div>
                            <span class="sr-only"> Phone Number - </span>
                            <label>{{ rowData.phone }}<span *ngIf="rowData.extension">&nbsp; extn.&nbsp;{{rowData.extension}}</span></label>
                        </div>
                    </div>
                </td>
                <td style="max-width: 30em;" data-label="Record Request Type" valign="top">{{ rowData.recordRequestType }}</td>
                <td data-label="Date of Services" valign="top">{{ rowData.dateOfServices }}</td>
                <td data-label="Status" valign="top">{{rowData.status || '--'}}</td>
                <td style="max-width: 19em;" data-label="Status Message" valign="top">
                <div class="d-flex flex-column" valign="top">
                    <ng-container *ngIf="rowData?.statusMessage && rowData?.statusUpdateDate; else noStatus">
                        <label>
                            <p class="status-message" [innerHTML]="rowData.statusMessage"></p>
                        </label>
                        <label class="text-muted">
                            As on: {{ rowData.statusUpdateDate | dateFormatter:'MM/dd/yyyy' }}
                        </label>
                    </ng-container>
                
                    <ng-template #noStatus>
                        <label class="text-muted">--</label>
                    </ng-template>
                </div>
                </td>
                <!-- <td data-label="Uploaded Documents">
                    @if(rowData.documents.length){
                    <i tabIndex="0" class="pi pi-check success-color fw-bold" ></i>
                    } @else {
                    --
                    }
                </td> -->
                <td valign="top">
                    <div class="d-flex flex-row gap-3 align-items-center">
                        <p-button
                            aria-label="Download Documents"
                            [class.invisible]="!rowData?.documents?.length"
                            type="button"
                            [text]="true"
                            styleClass="primary-color fs-6 fw-bold"
                            [link]="true"
                            icon="pi pi-download"
                            (click)="downloadMultipleFiles(rowData)">
                        </p-button>

                        @if(orderDetails?.clientActionRequired){
                            <i role="img" aria-label="client Action Required" [class.invisible]="!rowData?.clientActionRequired" class="pi pi-flag-fill " style="color: #D13438;"></i>
                        }
                         <i 
                            tabindex="0"
                            [pRowToggler]="rowData"
                            [attr.aria-label]="expandedRows[rowData.formattedId] ? 'Collapse row' : 'Expand row'"  
                            role="button"
                            [ngClass]="
                            expanded 
                            ? 'pi pi-chevron-circle-up icon-color fs-6' 
                            : 'pi pi-chevron-circle-down icon-color fs-6' "
                            (click)="toggleRow(rowData.formattedId, expanded)">
                        </i>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template #expandedrow let-rowData>
            <tr class="p-0">
                <td [attr.colspan]="9" class="p-0 expanded">
                    <div class="p-3 bg-pale-blue w-100">
                        <p-panel header="View Additional Details" [toggleable]="true" [(collapsed)]="rowData.additionalInfo.isCollapsed"
                            [showHeader]="rowData.additionalInfo.isCollapsed" class="custom-panel" *ngIf="detailsHasKeys(rowData.additionalInfo.details)"
                            >
                            <ng-template pTemplate="header">  
                                <button *ngIf="rowData.additionalInfo.isCollapsed" tabIndex="0"
                                    (click)="togglePanel(rowData.additionalInfo, $event)" class="p-button p-component p-button-link p-0 m-0 mb-3">
                                    View Additional Details <i class="pi pi-angle-down"></i>
                                </button>
                            </ng-template>
                            <!-- Replace the static content with dynamic binding -->
                            <div>
                                <label class="medium-text">Additional Details:</label>
                                <ul>
                                    @if(rowData.additionalInfo.details?.imaging){
                                    <li class="mb-2">
                                        <label class="text-underline semi-bold-text heading-color">Type of Imaging:</label>
                                        <div>
                                            <span>{{rowData.additionalInfo.details.imaging.type}}</span>
                                        </div>
                                        @if(rowData.additionalInfo.details?.imaging?.type?.includes('Other')){
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Other: </span>
                                                {{rowData.additionalInfo.details.imaging.comments}}
                                            </label>
                                        </div>
                                        }
                                        @if(rowData.additionalInfo.details?.imaging.bodyPart){
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Specific Body Part/Area: </span>
                                                {{rowData.additionalInfo.details.imaging.bodyPart}}
                                            </label>
                                        </div>
                                        }
                                    </li>
                                    }
                                    @if(rowData.additionalInfo.details?.ambulance){
                                    <li class="mb-2">
                                        <label class="text-underline semi-bold-text heading-color">Ambulance: </label>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Date of Ambulance Service: </span>
                                                {{rowData.additionalInfo.details.ambulance.dateOfService | date: 'MM/dd/yyyy'}}
                                            </label>
                                        </div>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Time of ambulance service: </span>
                                                {{rowData.additionalInfo.details.ambulance.timeOfService}}
                                            </label>
                                        </div>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Pick-up Address: </span>
                                                <span data-openreplay-obscured>{{rowData.additionalInfo.details.ambulance.pickupAddress}}</span>
                                            </label>
                                        </div>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Drop Address: </span>
                                                <span data-openreplay-obscured>{{rowData.additionalInfo.details.ambulance.dropAddress}}</span>
                                            </label>
                                        </div>
                                    </li>
                                    }
                                    @if(rowData.additionalInfo.details?.employment){
                                    <li class="mb-2">
                                        <label class="text-underline semi-bold-text heading-color">Employment: </label>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">SS#: </span>
                                                <span data-openreplay-obscured>{{rowData.additionalInfo.details.employment.ssn}}</span>
                                            </label>
                                        </div>
                                    </li>
                                    }
                                    @if(rowData.additionalInfo.details?.insurance){
                                    <li class="mb-2">
                                        <label class="text-underline semi-bold-text heading-color">Insurance: </label>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Claim Number: </span>
                                                {{rowData.additionalInfo.details.insurance.claimNumber}}
                                            </label>
                                        </div>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Policy Number: </span>
                                                {{rowData.additionalInfo.details.insurance.policyNumber}}
                                            </label>
                                        </div>
                                    </li>
                                    }
                                    @if(rowData.additionalInfo.details?.irs){
                                    <li class="mb-2">
                                        <label class="text-underline semi-bold-text heading-color">IRS: </label>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">SS#: </span>
                                                <span data-openreplay-obscured>{{rowData.additionalInfo.details.irs.ssn}}</span>
                                            </label>
                                        </div>
                                    </li>
                                    }
                                    @if(rowData.additionalInfo.details?.military){
                                    <li class="mb-2">
                                        <label class="text-underline semi-bold-text heading-color">Military: </label>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Branch (if known): </span>
                                                {{rowData.additionalInfo.details.military.branch}}
                                            </label>
                                        </div>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Service Number (if known): </span>
                                                {{rowData.additionalInfo.details.military.serviceNumber}}
                                            </label>
                                        </div>
                                    </li>
                                    }
                                    @if(rowData.additionalInfo.details?.socialSecurity){
                                    <li class="mb-2">
                                        <label class="text-underline semi-bold-text heading-color">Social Security: </label>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">SS#: </span>
                                                <span data-openreplay-obscured>{{rowData.additionalInfo.details.socialSecurity.ssn}}</span>
                                            </label>
                                        </div>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Record Subject Address: </span>
                                                <span data-openreplay-obscured>{{rowData.additionalInfo.details.socialSecurity.address}}</span>
                                            </label>
                                        </div>
                                    </li>
                                    }
                                    @if(rowData.additionalInfo.details?.union){
                                    <li class="mb-2">
                                        <label class="text-underline semi-bold-text heading-color">Union: </label>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Membership Number (if known): </span>
                                                {{rowData.additionalInfo.details.union.membershipNumber}}
                                            </label>
                                        </div>
                                    </li>
                                    }
                                    @if(rowData.additionalInfo.details?.va){
                                    <li class="mb-2">
                                        <label class="text-underline semi-bold-text heading-color">VA: </label>
                                        <div>
                                            <label>{{rowData.additionalInfo.details.va.details}}</label>
                                        </div>
                                    </li>
                                    }
                                    @if(rowData.additionalInfo.details?.other){
                                    <li class="mb-2">
                                        <label class="text-underline semi-bold-text heading-color">Other: </label>
                                        <div class="d-flex flex-row gap-1">
                                            <label><span class="medium-text">Description of records: </span>
                                                {{rowData.additionalInfo.details.other.recordDescription}}
                                            </label>
                                        </div>
                                    </li>
                                    }
                                </ul>
                            </div>
                            <ng-template pTemplate="footer">
                                <button *ngIf="!rowData.additionalInfo.isCollapsed" tabIndex="0"
                                    (click)="togglePanel(rowData.additionalInfo, $event)" class="p-button p-component p-button-link mb-3">
                                    Hide Additional Details <i class="pi pi-angle-up"></i>
                                </button>
                            </ng-template>
                        </p-panel>
                        <div class="d-flex flex-column gap-2">
                            <label class="semi-bold-text">Records Retrieved:</label>
                            @if (isDocumentsLoading) {
                                <div class="d-flex align-items-center gap-2">
                                    <i class="pi pi-spin pi-spinner"></i>
                                    <span>Loading documents...</span>
                                </div>
                            } @else if (rowData.documents?.length) {
                                @for(file of rowData.documents; let indx = $index; track file){
                                <div class="row">
                                    <div class="col-12 col-md-3 col-lg-3 text-truncate">
                                        <button tabIndex="0" class="p-0 m-0 p-button-link p-button p-component" (click)="downloadFile(file)">
                                            {{file.fileName}}
                                        </button>
                                    </div>
                                    <div class="col-9 col-md-3 custom-col-width">
                                        <span class="sr-only">Documents Types -</span>
                                        <label>{{file.tags}}</label>
                                    </div>
                                    <div class="col-1 col-md-2 col-lg-1">
                                        <p-button icon="pi pi-download" label=" Download" styleClass="p-0"
                                            (click)="downloadFile(file)" [link]="true" />
                                    </div>
                                </div>
                                }
                            } @else {
                                <div class="text-muted">
                                    No documents have been retrieved yet.
                                </div>
                            }
                        </div>
                        @if(rowData.statusMessage){
                            <div class="d-flex flex-column gap-2 mt-3">
                                <label class="semi-bold-text">Status Message:</label>
                                <!-- <label>
                                    {{rowData.statusMessage}}
                                </label> -->
                                <div [innerHtml]="rowData.statusMessage">

                                </div>
                            </div>
                        }
                    </div>
                </td>
            </tr>
        </ng-template>
        <p-popover #op styleClass="help-icon-popover">
            <div>
                <label class="semi-bold-text">Icon Overview </label>
                <p>This section describes the icons displayed on this screen.</p>
            </div>
            <ul class="dropdown-menu-list">
                <li class="d-flex flex-row align-items-center"><i class="pi pi-download primary-color me-2"></i>Download File</li>
                <li class="d-flex flex-row align-items-center"><i class="pi pi-flag-fill icon-color-red me-2"></i>Client Action</li>
                <li class="d-flex flex-row align-items-center"><i class="pi pi-chevron-circle-down icon-color me-2"></i>Expand</li>
            </ul>
          </p-popover>
    </p-table>
</div>